import { UntitledIcon, type UntitledIconData } from '@faceup/icons'
import { Typography } from '@faceup/ui-base'
import { AttachmentRedact } from '../Redaction'

const { Text } = Typography

type Attachment = { id: string; name: string; url: string; mimetype: string }
type AttachmentListProps = {
  icons: {
    attachment: UntitledIconData
  }
  attachments: Attachment[]
  download: (payload: Attachment) => void
  backgroundColor?: string
  color?: string
}

const ChatAttachmentList = (props: AttachmentListProps) => {
  if (!props.attachments.length) {
    return null
  }

  return (
    <div
      className='px-4 py-1'
      style={{ backgroundColor: props.backgroundColor ?? 'var(--color-colorInfoBg)' }}
    >
      {props.attachments.map(attachment => (
        <div key={attachment.url} className='flex max-w-full items-center gap-2 py-1'>
          <UntitledIcon className='shrink-0' icon={props.icons.attachment} />
          <div className='min-w-0'>
            <AttachmentRedact
              type={{
                type: 'attachments',
                id: attachment.id,
              }}
              text={attachment.name}
            >
              <Text
                underline
                onClick={() => props.download(attachment)}
                className='block cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap'
              >
                {attachment.name}
              </Text>
            </AttachmentRedact>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ChatAttachmentList
